import admin from "firebase-admin";
import { Readable } from "node:stream";
import { p as pollWorkflowJob } from "../../../../../../../chunks/octokit.js";
import { u as updateInstallerProgress } from "../../../../../../../chunks/utils.js";
const GET = async ({ locals }) => {
  const installerRef = admin.firestore().collection("installers").doc(locals.user?.email);
  const installer = await installerRef.get();
  const stream = new Readable({
    read() {
    }
  });
  const unsubscribe = installerRef.onSnapshot(
    (doc) => {
      const data = `event: update
data: ${JSON.stringify(doc.data())}

`;
      stream.push(data);
    },
    (error) => {
      const errorData = `event: error
data: ${JSON.stringify({ message: error.message })}

`;
      stream.push(errorData);
    }
  );
  pollWorkflowJob(installer.data()?.jobId, (job) => {
    const completed = job.steps?.filter((step) => step.status === "completed").length;
    const total = job.steps?.length;
    const progress = `${completed} / ${total}`;
    updateInstallerProgress(locals.user.email, { progress, status: job.status });
    if (job.status === "completed") {
      stream.destroy();
    }
  });
  stream.on("close", () => {
    unsubscribe();
  });
  return new Response(stream, {
    headers: {
      // SSE requires this content type
      "Content-Type": "text/event-stream",
      // Disables caching so the events stream live
      "Cache-Control": "no-cache",
      // Keep connection alive
      Connection: "keep-alive"
    }
  });
};
export {
  GET
};
